export const logInfo = (...args) => {
  if (logInfo.enabled && process.env.NODE_ENV !== 'production') {
    console.log(...args);
  }
};

logInfo.enabled = false;
